import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'md', 
  fullWidth = false, 
  children, 
  className = '',
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center font-bold transition-all duration-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-zinc-900 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-yellow-400 text-zinc-950 hover:bg-yellow-500 hover:shadow-lg hover:shadow-yellow-400/20 focus:ring-yellow-400",
    secondary: "bg-zinc-800 text-white hover:bg-zinc-700 hover:shadow-lg hover:shadow-zinc-700/20 focus:ring-zinc-600 border border-zinc-700",
    outline: "border-2 border-zinc-700 text-zinc-300 bg-transparent hover:border-yellow-400 hover:text-yellow-400 focus:ring-zinc-600",
    ghost: "text-zinc-400 hover:bg-zinc-800 hover:text-white focus:ring-zinc-600"
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-5 py-2.5 text-base",
    lg: "px-8 py-3.5 text-lg"
  };

  const width = fullWidth ? "w-full" : "";

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;